import React, { useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  coldarkCold,
  zTouch,
} from "react-syntax-highlighter/dist/esm/styles/prism";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Box, Fade } from "@mui/material";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import curlSvg from "../Images/curlsvg.svg"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1100,
  backgroundColor: "#000",
  border: "none",
  borderRadius: "10px",
  overflow: "hidden",
  boxShadow: 24,
  // p: 2,
};

const ApiKeyCodeViewComponent = (props) => {
  const [activeBtnId, selectedBtnId] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isResponsCopied, setIsResponsCopied] = useState(false);
  const [isCodeCopied, setIsCodeCopied] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const buttonsArray = [
    {
      id: 1,
      svg: curlSvg,
      text: "cURL",
      img: true,
      codeString: `curl --location ${props.url}`,
    },
    {
      id: 2,
      svg: "https://developer.instantly.ai/icons/icons8-ruby-programming-language.svg",
      text: "Ruby",
      img: true,
      codeString: `require "uri"
require "json"
require "net/http"

url = URI("${props.url}")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Get.new(url)
request["Content-Type"] = "application/json"

response = https.request(request)

puts response.read_body`,
    },
    {
      id: 3,
      svg: "https://developer.instantly.ai/icons/icons8-python.svg",
      text: "Python",
      img: true,
      codeString: `import requests
import json

url = "${props.url}"

payload = {}
headers = {
  'Content-Type': 'application/json'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)`,
    },
    {
      id: 4,
      svg: "https://developer.instantly.ai/icons/icons8-php-logo.svg",
      text: "PHP",
      img: true,
      codeString: `<?php
$client = new Client();
$headers = [
  'Content-Type' => 'application/json'
];
$request = new Request('GET', ${props.url}, $headers);
$res = $client->sendAsync($request)->wait();
echo $res->getBody();`,
    },
    {
      id: 5,
      svg: "https://developer.instantly.ai/icons/icons8-java.svg",
      text: "Java",
      img: true,
      codeString: `OkHttpClient client = new OkHttpClient().newBuilder().build();
MediaType mediaType = MediaType.parse("application/json");
RequestBody body = RequestBody.create(mediaType, "");
Request request = new Request.Builder()
.url("${props.url}")
.method("GET", body)
.addHeader("Content-Type", "application/json")
.build();
Response response = client.newCall(request).execute();`,
    },
    {
      id: 6,
      svg: "https://developer.instantly.ai/icons/icons8-nodejs.svg",
      text: "Node.js",
      img: true,
      codeString: `var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow'
};

fetch("${props.url}", requestOptions)
.then(response => response.text())
.then(result => console.log(result))
.catch(error => console.log('error', error));`,
    },
    {
      id: 7,
      svg: "https://go.dev/blog/go-brand/Go-Logo/SVG/Go-Logo_LightBlue.svg",
      text: "Go",
      img: true,
      codeString: `package main
  
import (
  "fmt"
  "net/http"
  "io/ioutil"
)

func main() {
  url := "${props.url}"
  method := "GET"

  client := &http.Client {
  }
  req, err := http.NewRequest(method, url, nil)

  if err != nil {
    fmt.Println(err)
    return
  }
  req.Header.Add("Content-Type", "application/json")

  res, err := client.Do(req)
  if err != nil {
    fmt.Println(err)
    return
  }
  defer res.Body.Close()

  body, err := ioutil.ReadAll(res.Body)
  if err != nil {
    fmt.Println(err)
    return
  }
  fmt.Println(string(body))
}`,
    },
    {
      id: 8,
      svg: "https://developer.instantly.ai/icons/microsoft-dot-net.webp",
      text: ".NET",
      img: true,
      codeString: `var client = new HttpClient();
var request = new HttpRequestMessage(HttpMethod.Get, "${props.url}");
var content = new StringContent(string.Empty);
content.Headers.ContentType = new MediaTypeHeaderValue("application/json");
request.Content = content;
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());`,
    },
  ];

  const codeString = `[
    {
      "Duration": "{}",
      "SendOption": "{}",
      "CCEmail": "[]",
      "BCCEmail": "[]",
      "ABTesting": "boolean",
      "_id": "293nd93nndj2nmds3kfk34sr",
      "UserId": "637ee2837hfgd3883nds632sgf",
      "Name": "My first campaign",
      "Status": "Ongoing",
      "CountryDateTime": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
      "Day": [
        {
            "Day": "Sunday",
            "StartHour": start hour,
            "StartMinute": start minutes,
            "EndHour": end hour,
            "EndMinute": end minutes,
            "_id": "657d824608269fa43949d0b2"
        }
      ],
      "FromEmail": [
        {
            "FromEmail": "example@gmail.com",
            "FromName": "name",
            "Password": "skwnoshygprfweqw",
            "Service": boolean,
            "ServiceName": "gmail",
            "Limit": number,
            "Code": number,
            "Port": number,
            "Host": "smtp.gmail.com",
            "ImapEmail": "example@gmail.com",
            "ImapUsername": "name",
            "ImapPassword": "skwnoshygprfweqw",
            "ImapHost": "imap.gmail.com",
            "ImapPort": number,
            "_id": "657d91aawdt21dfce9d63de"
        }
    ],
    "ToEmail": [
        {
            "ToEmail": "example@gmail.com",
            "ToName": "name",
            "ToPhone": "mobile number",
            "ToFirstName": "first name",
            "ToLastName": "last name",
            "ToCompanyName": "company name",
            "ToWebsite": "website",
            "_id": "657d91sz2jfhd1dfce9d63df"
        }
      ],
      "AllContact": boolean,
      "TimeGap": number,
      "MissingVariable": boolean,
      "StopOnReply": boolean,
      "createdAt": "ISO 8601 format timestamp",
      "updatedAt": "ISO 8601 format timestamp",
    }
  ]`;

  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#252940",
                padding: "6px 8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexGrow: 1,
                  gap: "2px",
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    color:
                      props.method === "GET" || props.method === "PUT"
                        ? "#31A5EE"
                        : props.method === "POST"
                        ? "#fab432"
                        : "#ff5c6c",
                    letterSpacing: 1,
                  }}
                >
                  {props.method}
                </p>
                <input
                  type="text"
                  disabled
                  spellCheck={false}
                  value={`${props.url}`}
                  style={{
                    backgroundColor: "transparent",
                    color: "#FFF",
                    flexGrow: 1,
                    padding: "2px 4px",
                    fontSize: "16px",
                    outline: "none",
                    cursor: "default",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {dropDownUi()}
                <button
                  style={{ outline: "none" }}
                  onClick={handleCodeCopyClick}
                >
                  {!isCodeCopied ? (
                    <ContentCopyOutlinedIcon
                      sx={{
                        color: "#FFF",
                        fontSize: "18px",
                        marginTop: "-4px",
                      }}
                    />
                  ) : (
                    <CheckOutlinedIcon
                      sx={{
                        color: "#FFF",
                        fontSize: "18px",
                        marginTop: "-4px",
                      }}
                    />
                  )}
                </button>
                <button
                  style={{ outline: "none" }}
                  onClick={() => setOpenModal(false)}
                >
                  <CloseRoundedIcon sx={{ color: "#FFF" }} />
                </button>
              </div>
            </div>
            <div>
              <SyntaxHighlighter
                customStyle={{
                  margin: "0px",
                  borderRadius: "0px",
                  maxHeight: "350px",
                  overflow: "auto",
                }}
                language="jsx"
                style={zTouch}
                showLineNumbers={true}
              >
                {buttonsArray[activeBtnId - 1].codeString}
              </SyntaxHighlighter>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const responseMuiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openResponseModal}
        onClose={() => setOpenResponseModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openResponseModal}>
          <Box sx={style}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#252940",
                padding: "14px 22px",
              }}
            >
              <p
                style={{
                  fontWeight: 700,
                  color: "#FFF",
                  letterSpacing: 1.5,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                RESPONSE
                <span
                  style={{
                    backgroundColor: "#DCECEB",
                    color: "#1C485F",
                    padding: "2px 4px",
                    borderRadius: "4px",
                  }}
                >
                  200 OK
                </span>
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                }}
              >
                <button style={{ outline: "none" }} onClick={handleCopyClick}>
                  {!isResponsCopied ? (
                    <ContentCopyOutlinedIcon
                      sx={{
                        color: "#FFF",
                        fontSize: "18px",
                        marginTop: "-4px",
                      }}
                    />
                  ) : (
                    <CheckOutlinedIcon
                      sx={{
                        color: "#FFF",
                        fontSize: "18px",
                        marginTop: "-4px",
                      }}
                    />
                  )}
                </button>
                <button
                  style={{ outline: "none" }}
                  onClick={() => setOpenResponseModal(false)}
                >
                  <CloseRoundedIcon sx={{ color: "#FFF" }} />
                </button>
              </div>
            </div>
            <div>
              <SyntaxHighlighter
                customStyle={{
                  margin: "0px",
                  borderRadius: "0px",
                  maxHeight: "350px",
                  overflow: "auto",
                }}
                language="jsx"
                style={zTouch}
                showLineNumbers={true}
              >
                {props.response}
              </SyntaxHighlighter>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const dropDownUi = () => {
    return (
      <div>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          disableRipple
          disableTouchRipple
          sx={{
            outline: "none !important",
            padding: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
            color: "white",
            fontsize: "12px",
          }}
        >
          {buttonsArray[activeBtnId - 1].text}
          {open ? (
            <ExpandLessRoundedIcon
              sx={{ fontsize: "14px", marginTop: "-2px" }}
            />
          ) : (
            <ExpandMoreRoundedIcon
              sx={{ fontsize: "14px", marginTop: "-2px" }}
            />
          )}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          PaperProps={{
            sx: {
              width: 250,
              maxWidth: "100%",
            },
          }}
        >
          <MenuList sx={{ maxHeight: 250, overflow: "auto" }}>
            {buttonsArray.map((item, index) => [
              <MenuItem
                onClick={() => {
                  selectedBtnId(item.id);
                  setAnchorEl(null);
                  // if(openModal) setOpenModal(false);
                }}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom:
                    index < buttonsArray.length - 1 ? "1px solid #DDD" : "none",
                  backgroundColor: activeBtnId === item.id ? "#D1DFE9" : "none",
                  "&:hover": {
                    background: "#D1DFE9",
                  },
                }}
              >
                <p style={{ fontSize: "14px", color: "#868686" }}>
                  {item.text}
                </p>
                <CheckOutlinedIcon
                  sx={{
                    color: "#868686",
                    fontSize: "medium",
                  }}
                />
              </MenuItem>,
            ])}
          </MenuList>
        </Menu>
      </div>
    );
  };

  const handleCodeCopyClick = async () => {
    try {
      // Attempt to copy the code string to the clipboard
      await navigator.clipboard.writeText(
        buttonsArray[activeBtnId - 1].codeString
      );
      setIsCodeCopied(true);
      // Reset isResponseCopied after 3 seconds (3000 milliseconds)
      setTimeout(() => {
        setIsCodeCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Unable to copy code to clipboard:", err);
    }
  };

  const handleCopyClick = async () => {
    try {
      // Attempt to copy the code string to the clipboard
      await navigator.clipboard.writeText(codeString);
      console.log("Code copied to clipboard!");
      setIsResponsCopied(true);
      // Reset isResponseCopied after 3 seconds (3000 milliseconds)
      setTimeout(() => {
        setIsResponsCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Unable to copy code to clipboard:", err);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <div
          style={{
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "#F3F6FC",
          }}
        >
          <div
            style={{
              backgroundColor: "#52617D",
              padding: "16px 12px",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#FFF",
                letterSpacing: 1.5,
              }}
            >
              LANGUAGE BOX
            </p>
          </div>
          <div
            style={{
              padding: "24px 12px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {buttonsArray.map((button) => (
              <button
                onClick={() => selectedBtnId(button.id)}
                key={button.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  alignItems: "center",
                  borderBottom: `1.5px solid ${
                    activeBtnId === button.id ? "#fc9630" : "#DDD"
                  }`,
                  outline: "none",
                }}
              >
                {button.img ? (
                  <img
                    src={button.svg}
                    style={{ height: "30px", marginBottom: "6px" }}
                    alt={`${button.text.toLowerCase()}-logo`}
                  />
                ) : (
                  button.svg
                )}
                <span>{button.text}</span>
              </button>
            ))}
          </div>
        </div>
        <div
          style={{
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "#F3F6FC",
          }}
        >
          <div
            style={{
              backgroundColor: "#52617D",
              padding: "16px 12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
                gap: "2px",
              }}
            >
              <p
                style={{
                  fontWeight: 700,
                  color:
                    props.method === "GET" || props.method === "PUT"
                      ? "#31A5EE"
                      : props.method === "POST"
                      ? "#fab432"
                      : "#ff5c6c",
                  letterSpacing: 1,
                }}
              >
                {props.method}
              </p>
              <input
                type="text"
                disabled
                spellCheck={false}
                value={`https://mail.coldsender.com/email-marketing/automation/get-campaign-list-api-key?limit=2`}
                style={{
                  backgroundColor: "transparent",
                  color: "#FFF",
                  flexGrow: 1,
                  padding: "2px 4px",
                  fontSize: "16px",
                  outline: "none",
                  cursor: "default",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {dropDownUi()}
              <button style={{ outline: "none" }} onClick={handleCodeCopyClick}>
                {!isCodeCopied ? (
                  <ContentCopyOutlinedIcon
                    sx={{
                      color: "#FFF",
                      fontSize: "18px",
                      marginTop: "-4px",
                    }}
                  />
                ) : (
                  <CheckOutlinedIcon
                    sx={{
                      color: "#FFF",
                      fontSize: "18px",
                      marginTop: "-4px",
                    }}
                  />
                )}
              </button>
              <button
                style={{ outline: "none" }}
                onClick={() => setOpenModal(true)}
              >
                <FullscreenOutlinedIcon sx={{ color: "#FFF" }} />
              </button>
            </div>
          </div>
          <div>
            <SyntaxHighlighter
              language="jsx"
              style={zTouch}
              showLineNumbers={true}
              customStyle={{
                margin: "0px",
                borderRadius: "0px",
                maxHeight: "300px",
                overflow: "auto",
              }}
            >
              {buttonsArray[activeBtnId - 1].codeString}
            </SyntaxHighlighter>
          </div>
        </div>
        <div
          style={{
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "#F3F6FC",
          }}
        >
          <div
            style={{
              backgroundColor: "#52617D",
              padding: "16px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#FFF",
                letterSpacing: 1.5,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              RESPONSE
              <span
                style={{
                  backgroundColor: "#DCECEB",
                  color: "#1C485F",
                  padding: "2px 4px",
                  borderRadius: "4px",
                }}
              >
                200 OK
              </span>
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <button style={{ outline: "none" }} onClick={handleCopyClick}>
                {!isResponsCopied ? (
                  <ContentCopyOutlinedIcon
                    sx={{
                      color: "#FFF",
                      fontSize: "18px",
                      marginTop: "-4px",
                    }}
                  />
                ) : (
                  <CheckOutlinedIcon
                    sx={{
                      color: "#FFF",
                      fontSize: "18px",
                      marginTop: "-4px",
                    }}
                  />
                )}
              </button>
              <button
                style={{ outline: "none" }}
                onClick={() => setOpenResponseModal(true)}
              >
                <FullscreenOutlinedIcon sx={{ color: "#FFF" }} />
              </button>
            </div>
          </div>
          <div>
            <SyntaxHighlighter
              customStyle={{
                margin: "0px",
                borderRadius: "0px",
                height: "250px",
                overflow: "auto",
              }}
              language="jsx"
              style={coldarkCold}
              showLineNumbers={true}
            >
              {props.response}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>
      {openModal && muiModal()}
      {openResponseModal && responseMuiModal()}
    </>
  );
};

export default ApiKeyCodeViewComponent;
